import { encore } from '@saucelabs/sl-util-axios';

export const getColumns = () => (
  encore.get('/api/page_preferences/archives/columns')
);

export const putColumns = (payload) => (
  encore.put('/api/page_preferences/archives/columns', payload)
);
